import React from 'react';
import { Button, Typography, Notify as AlertNotify } from "../..";
import PropTypes from 'prop-types';
const ImportComp = ({
  components,
  from = 'components',
  importDefault = false
}) => {
  let text = Array.isArray(components) ? components.join(', ') : components;
  if (!importDefault) {
    text = `{ ${text} }`;
  }
  const importText = `import ${text} from 'diginet-core-ui/${from}';`;
  let Notify = null;
  const onCopyImport = () => {
    if (!components) {
      Notify(`Không có components để copy`, {
        color: 'warning'
      });
      return;
    }
    const el = document.createElement('input');
    el.value = importText;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    Notify(`Đã copy ${text} from ${from}`);
  };
  return components ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      position: 'sticky',
      justifyContent: 'flex-end',
      alignItems: 'center',
      top: 0,
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    type: 'h3',
    color: 'primary',
    style: {
      fontSize: 14
    }
  }, importText), /*#__PURE__*/React.createElement(Button, {
    onClick: onCopyImport,
    text: 'Copy',
    viewType: 'filled',
    color: 'info',
    size: 'tiny'
  }), /*#__PURE__*/React.createElement(AlertNotify, {
    getAddNotify: func => Notify = func,
    progressing: true,
    autoDisappear: true,
    maxWidth: '500px',
    color: 'success'
  })) : /*#__PURE__*/React.createElement(Typography, {
    type: 'h1',
    color: 'danger',
    center: true
  }, "DEVELOPING", ' ', /*#__PURE__*/React.createElement(Typography, {
    type: 'h3',
    color: 'warning'
  }, "(Khoan h\u1EB5n d\xF9ng)"));
};
ImportComp.propTypes = {
  components: PropTypes.string,
  from: PropTypes.string,
  importDefault: PropTypes.bool
};
export default ImportComp;